import api from '@disco/api/server'
import captureError from '@disco/utils/captureError'
import { isAggregatedSearchTrack } from '@disco/utils/tracks'

import type { Track } from 'types/track'

/**
 * Fetches the full track (with metadata) for local rendering purposes.
 * Falls back to the passed track when the request fails.
 */
export const fetchTrackMetadata = async (track: Track): Promise<Track> => {
  // can't dispatch() an action - this is a hot zone
  // TODO: we have to update track everytime track info is fetched,
  // in this case too, but I leave it for later as it's fetched for local
  // rendering purposes
  try {
    if (isAggregatedSearchTrack(track)) {
      return await api.getAggregatedTrackByUrl(track.url)
    }

    return await api.getTrack(track.id)
  } catch (e) {
    captureError(e, { description: 'Failed to fetch track metadata' })
  }

  return track
}
